import { Plus } from 'lucide-react';
import type { SettingListOption } from '@peles/shared';
import { SidePanelTabs } from './SidePanelTabs';
import { describePlanPart, type PlanPartFields } from './planParts';

interface PlanPartTabsProps {
  /** The event's plans, in the order the evening runs. */
  plans: readonly (PlanPartFields & { id: string; name: string })[];
  parts: readonly SettingListOption[];
  activeId: string | null;
  onSelect: (planId: string) => void;
  /** Lay out another part of the evening. */
  onAddPart: () => void;
}

/**
 * An event's plans as the parts of its evening — Ceremony · 5:00 PM, Dinner ·
 * 7:30 PM — one tab each, in the order they run, and a way to lay out the
 * next part. A plan for no part is named by its own name.
 */
export function PlanPartTabs({ plans, parts, activeId, onSelect, onAddPart }: PlanPartTabsProps) {
  const tabs = plans.map((p) => ({
    id: p.id,
    label: describePlanPart(p, parts) ?? p.name,
    testId: `plan-part-tab-${p.id}`,
  }));
  return (
    <div className="flex flex-wrap items-start gap-2" data-testid="plan-part-tabs">
      {tabs.length > 0 && (
        <SidePanelTabs
          tabs={tabs}
          active={activeId ?? ''}
          onChange={onSelect}
          ariaLabel="Parts of the evening"
        />
      )}
      <button
        type="button"
        onClick={onAddPart}
        className="flex items-center gap-1 px-2 py-1 text-xs rounded text-primary-700 hover:bg-primary-50"
        data-testid="add-plan-part-btn"
      >
        <Plus size={12} />
        Add part
      </button>
    </div>
  );
}
